import { generateRequest } from '.';

export const Action = {
  Auth: {
    LoginCompleted: 'Login_FULFILLED',
    LoginFailed: 'Login_FAILED',
    LoginPending: 'Login_PENDING',
    LoggedOut: 'Logout_FULFILLED',
    LoginIfVerifiedCompleted: 'LoginIfVerified_FULFILLED',
    LoginIfVerifiedFailed: 'LoginIfVerified_FAILED',
    LoginIfVerifiedPending: 'LoginIfVerified_PENDING',
  },
};

export const loginIfVerified = ({ identityHost, token }) => generateRequest({
  method: 'POST',
  credentials: 'include', // include cookies even for cross origin calls
  endpoint: `//${identityHost}/social/login/google`,
  types: [
    Action.Auth.LoginIfVerifiedPending,
    Action.Auth.LoginIfVerifiedCompleted,
    Action.Auth.LoginIfVerifiedFailed,
  ],
  body: { token },
});
